import { useStyle } from "@pages/Home/broadband/style";
import { HomeBroadband } from "@features/home/broadband/HomeBroadband";

export const HomeBroadbandPage = () => {
    const { classes } = useStyle();

    return (
        <div className={classes.broadbandPage}>
            <HomeBroadband />
        </div>
    );
};
